import { render, staticRenderFns } from "./ProjectType.vue?vue&type=template&id=2f3d86e2&"
import script from "./ProjectType.vue?vue&type=script&lang=js&"
export * from "./ProjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports